import type { NavLink, VerticalNavItemsType } from 'src/@core/layouts/types'
import { ROUTES } from '@/src/utils/routes'
import { isNavGroup } from './navGuards'

/**
 * Pulls the top-level Home link out of the vertical nav so the BHYBE rail can pin it above the drill menu.
 */
export function partitionBhyveRailNav(items: VerticalNavItemsType): {
  homeLink: NavLink | null
  menuRootItems: VerticalNavItemsType
} {
  if (!items.length) return { homeLink: null, menuRootItems: items }

  const first = items[0]
  if (isNavGroup(first)) {
    return { homeLink: null, menuRootItems: items }
  }

  const link = first as NavLink
  if (link.title !== 'Home') {
    return { homeLink: null, menuRootItems: items }
  }

  const p = link.path?.replace(/\/$/, '') ?? ''
  const resto = ROUTES.RESTAURANT.replace(/\/$/, '')
  if (p !== resto) {
    return { homeLink: null, menuRootItems: items }
  }

  return { homeLink: link, menuRootItems: items.slice(1) }
}
